module.exports = __webpack_public_path__ + "media/images/background-7fd9eaaaa2bfec598478ddfb9ef24ada.jpg";